var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "contest-entry-complete" }, [
    _vm._m(0),
    _c("h2", [_vm._v(_vm._s(_vm.$t("agentEntryComplete.title")))]),
    _c("div", { staticClass: "content" }, [
      _c("p", [_vm._v(_vm._s(_vm.$t("agentEntryComplete.thankYou")))]),
      _c("p", {
        domProps: {
          innerHTML: _vm._s(_vm.$t("agentEntryComplete.description2")),
        },
      }),
      _c("p", [_vm._v(_vm._s(_vm.$t("agentEntryComplete.description3")))]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "image" }, [
      _c("img", {
        attrs: { src: require("@/assets/img/event/agent/complete.webp") },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }